import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forBigDesktopUp, forPhoneOnly } from 'src/config/mediaQueries'

const textGeneral = {
  maxWidth: '325px',
  textAlign: 'center',
  margin: 0,
}

export const BIG_PHONE_ICON_SIZE = 18
export const SMALL_PHONE_ICON_SIZE = 15

export default createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 24,

    [forBigDesktopUp]: {
      paddingTop: 32,
    },
  },

  image: {
    [forPhoneOnly]: {
      width: 171,
    },
  },

  text: {
    ...textGeneral,
    ...typography['Lato H5'],
    marginTop: 48,
    [forPhoneOnly]: {
      ...typography['Lato Body 1'],
      marginTop: 40,
    },
  },

  callHeading: {
    ...textGeneral,
    ...typography['Lato H5 Bold'],
    marginTop: 16,
    [forPhoneOnly]: {
      ...typography['Lato Emphasized 1'],
    },
  },

  callNow: {
    marginTop: 48,
    marginBottom: 8,
    ...typography['Lato H5 Bold'],
    [forPhoneOnly]: {
      ...typography['Lato Emphasized 1'],
      marginTop: 40,
    },
  },
  phoneIcon: {
    width: BIG_PHONE_ICON_SIZE,
    height: BIG_PHONE_ICON_SIZE,
    [forPhoneOnly]: {
      width: SMALL_PHONE_ICON_SIZE,
      height: SMALL_PHONE_ICON_SIZE,
    },
  },
})
